import { render, staticRenderFns } from "./NoAdBlock.vue?vue&type=template&id=6bafcf7d&scoped=true"
import script from "./NoAdBlock.vue?vue&type=script&lang=js"
export * from "./NoAdBlock.vue?vue&type=script&lang=js"
import style0 from "./NoAdBlock.vue?vue&type=style&index=0&id=6bafcf7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bafcf7d",
  null
  
)

export default component.exports